/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import deepUiLib from './deep-ui-lib'
import fontawesome from './fontawesome'
import { i18n } from './i18n'
import vuetify from './vuetify'
import './deep-libs'
import { createPinia } from 'pinia'
import { getRouter } from './router'
// Types
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app.use(createPinia())
  app.use(i18n)
  app.use(fontawesome)
  app.use(vuetify)
  app.use(deepUiLib)

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(getRouter())
}
